import classes from './CommonButton.module.css'

const CommonButton = ({title, className, style, onClick}) => {
    return(
        <button className={`d-flex align-items-center justify-content-center ${classes.wrapper} ${className}`} style={style} role='button' onClick={onClick}>{title}</button>
    )
}

export default CommonButton